import { ArrowLeft } from "lucide-react";

export default function Impressum() {
  return (
    <div data-testid="impressum-page" className="min-h-screen bg-paper font-jakarta text-[#0A272C]">
      <header className="border-b border-[#0A272C]/10 bg-surface/80 backdrop-blur-xl">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 py-4 flex items-center justify-between">
          <a href="/" data-testid="impressum-logo" className="flex items-center hover:opacity-80 transition-opacity">
            <img src="/logo.png" alt="BUNDLER FM" className="h-7 w-auto" />
          </a>
          <a
            href="/"
            data-testid="impressum-back-link"
            className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-[#003940] transition-colors"
          >
            <ArrowLeft size={15} />
            Zurück zur Startseite
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-16 space-y-10">
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#003940]">Rechtliches</p>
          <h1 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight">Impressum</h1>
        </div>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">Angaben gemäß § 5 DDG</h2>
          <p className="text-slate-700 leading-relaxed">
            BUNDLER FM — UG in Gründung
            <br />
            Zum Isetal 1
            <br />
            38518 Gifhorn
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">Vertreten durch</h2>
          <p className="text-slate-700 leading-relaxed">Aleksandar Veljkovic (Geschäftsführung)</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">Kontakt</h2>
          <p className="text-slate-700 leading-relaxed">
            Telefon: +49 5371 9394742 (Festnetz)
            <br />
            Mobil (DE): +49 177 2185585
            <br />
            Mobil (SRB): +381 60 561 6892
            <br />
            E-Mail:{" "}
            <a href="mailto:info@bundler-fm.de" className="text-[#003940] underline underline-offset-4">
              info@bundler-fm.de
            </a>
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">Registereintrag</h2>
          <p className="text-slate-700 leading-relaxed">
            Die Umwandlung in eine UG (haftungsbeschränkt) befindet sich derzeit in Gründung.
            <br />
            Der Registereintrag wird nach Abschluss der Gründung an dieser Stelle ergänzt.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">Umsatzsteuer-ID</h2>
          <p className="text-slate-700 leading-relaxed">
            Eine Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz wird nach Erteilung an dieser
            Stelle ergänzt.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p className="text-slate-700 leading-relaxed">Mirzet Muhic, Anschrift wie oben</p>
        </section>

        <p className="text-xs text-slate-500 font-mono border-t border-slate-200 pt-6">
          Hinweis: Registereintrag und Umsatzsteuer-ID werden nach Abschluss der UG-Gründung ergänzt.
        </p>
      </main>
    </div>
  );
}
